import { Configuration } from "@azure/msal-browser";

export const resetPasswordUri: string = process.env.REACT_APP_B2C_RPURI;

export const loginUri: string = process.env.REACT_APP_B2C_SUSIURI;

export const scopes: Array<string> = process.env.REACT_APP_B2C_SCOPES.split(',');

export const partnerOrigin: string = process.env.REACT_APP_PARTNER_ORIGIN || '';

/**
 * Query param name used as secondary iframe detection signal.
 * The partner site must append this param to the iframe src URL.
 * Example: https://vendor-portal.com?partner_embed=true
 */
export const partnerEmbedParam: string = process.env.REACT_APP_PARTNER_PARAM || 'partner_embed';

export const msalInstance: Configuration = {
    auth: {
        clientId: process.env.REACT_APP_B2C_CLIENTID,
        authority: loginUri,
        knownAuthorities: [process.env.REACT_APP_B2C_AUTHORITY],
        redirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false,
    }
};

/**
 * Returns true when the app is running inside an iframe and the parent page
 * matches the configured partner origin.
 *
 * Uses two signals in order:
 * 1. document.referrer — reliable in most browsers.
 * 2. Query param (partnerEmbedParam=true) — fallback when the parent site
 *    sets Referrer-Policy: no-referrer and the referrer is unavailable.
 *
 * The partner site must append ?partner_embed=true to the iframe src URL
 * so the secondary signal is available regardless of referrer policy.
 */
export function isEmbeddedFromPartner(): boolean {
    if (window.self === window.top) return false;
    if (!partnerOrigin) return false;

    // Primary signal: document.referrer
    try {
        const referrerOrigin = new URL(document.referrer).origin;
        if (referrerOrigin === partnerOrigin) {
            console.info('[IframeDetect] Partner origin matched via document.referrer');
            return true;
        }
    } catch {
        // referrer is empty or not a valid URL — fall through to secondary signal
    }

    // Secondary signal: query param (covers Referrer-Policy: no-referrer)
    const params = new URLSearchParams(window.location.search);
    if (params.get(partnerEmbedParam) === 'true') {
        console.info('[IframeDetect] Partner origin matched via query param:', partnerEmbedParam);
        return true;
    }

    return false;
}